import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";

type AppCustomPropertyCheckboxSingleProps = {
  customProperty: CustomProperty;
  data: any;
  disabled: boolean;
  validate: boolean;
  onChange: (label: string, data: any) => void;
};

export const AppCustomPropertyCheckboxSingle = ({
  customProperty,
  data,
  disabled,
  validate,
  onChange,
}: AppCustomPropertyCheckboxSingleProps) => {
  const [checked, setChecked] = useState<boolean>(
    data ? data : JSON.parse(customProperty.settings || "{}").checked || false
  );
  const [choice, setChoice] = useState<string>(
    data ? data : JSON.parse(customProperty.settings || "{}").choice || ""
  );

  useEffect(() => {
    onChange(customProperty.label, checked);
  }, [checked]);

  return (
    <div className="app-custom-property-checkboxsingle">
      <input
        title={customProperty.label}
        disabled={disabled}
        type="checkbox"
        name={customProperty.label}
        checked={checked}
        onChange={(event) => {
          setChecked(event.target.checked);
        }}
      />

      {choice && (
        <div className="app-custom-property-checkboxsingle-choice">
          {choice}
        </div>
      )}

    </div>
  );
};
